<template>
  <Slider :slides="shuffled" title="common.question" v-slot="{ currentSlide, slide: { answers, correct_answer }, methods: { nextSlide } }">
    <div :class="$style.answer_wrapper">
      <div
        v-for="({id, text}) in answers"
        :class="[$style.answer, 'btn']"
        @click="answer(id, correct_answer, currentSlide, nextSlide)"
        v-html="$options.filters.translate(text)"
      ></div>
    </div>
  </Slider>
</template>

<style lang="scss" module>
  :root {
    --quiz-columns: 1;
    @media (max-width: 1000px) {
      --quiz-columns: 1;
    }
  }
  .answer_wrapper {
    display: grid;
    grid-template-columns: repeat(var(--quiz-columns), auto);
    grid-template-rows: repeat(2, 1fr);
    grid-gap: 1em;
    width: 100%;
    .answer {
      white-space: normal!important;
    }
  }
</style>

<script>
// @ is an alias to /src
import axios from 'axios';
import Slider from '@/components/Slider.vue';

import shuffleArray from '../helpers/shuffleArray';

export default {
  name: 'quiz',
  data() {
    return {
      passed: true,
      answers: {},
    };
  },
  computed: {
    shuffled() {
      const questions = this.$store.getters.getQuestionsForLevel(this.$store.getters.getLevel);
      return shuffleArray(questions).map((question) => {
        let answers = shuffleArray(question.answers);
        const correctIndex = answers.findIndex((answer => question.correct_answer === answer.id));
        const correctAnswer = answers.splice(correctIndex, 1);
        answers = shuffleArray([...answers.splice(0, 3), ...correctAnswer]);

        return {
          ...question,
          answers,
        };
      }).slice(0, 5);
    },
  },
  components: {
    Slider,
  },
  methods: {
    answer(answer, correctAnswer, curruntSlide, nextSlide) {
      const questionId = this.shuffled[curruntSlide].id;
      this.answers[questionId] = answer;

      if (answer !== correctAnswer) {
        this.passed = false;
      }
      if (curruntSlide === this.shuffled.length - 1) {
        return this.verify();
      }
      return nextSlide();
    },
    verify() {
      axios.post('https://acl.new.pixel-kraft.de/api/grantAccess', {
        answers: this.answers,
        visitor: this.$store.getters.getVisitor.id,
      }).then(({ data: { data: { status } } }) => {
        this.$router.push({ name: 'status', params: { passed: status } });
      });
    },
  },
  created() {
    if (this.$store.getters.getQuestions.length === 0) {
      this.$store.dispatch('getQuestions');
    }
  },
};
</script>
